import RestModule from "../vue-ocom/store/RestModule.js";
import schema from "./schema/index";
import { FileSystemModule } from "../vue-ocom/filesystem/store.js";

import * as CONFIG from "../config.js";
var root_url = CONFIG.root_url;

const CodeDocumentTypeModule = RestModule(
  root_url + "/dms/code_document_type/",
  schema.CodeDocumentType
);
const DocumentModule = RestModule(root_url + "/dms/document/", schema.Document);
const DocumentVersionModule = RestModule(
  root_url + "/dms/document_version/",
  schema.DocumentVersion
);
const DocumentCategoryModule = RestModule(
  root_url + "/dms/document_category/",
  schema.DocumentCategory
);
const DocumentReadModule = RestModule(
  root_url + "/dms/document_read/",
  schema.DocumentRead
);
//Add more modules here if needed. These will automatically be included and available in main store.

export default {
  CodeDocumentTypeModule,
  DocumentModule,
  DocumentVersionModule,
  DocumentCategoryModule,
  DocumentReadModule,
  FileSystemModule,
  //Add more modules here
};
